import * as React from 'react';
import './index.css';
export default class ErrorPane extends React.Component {
    render() {
        const list = [];
        let i = 1;
        if (this.props.error) {
            list.push(React.createElement("li", { key: 0 },
                React.createElement("span", { className: "error" }, "[Error] "),
                this.props.error.message));
        }
        this.props.errors.forEach((error) => {
            list.push(React.createElement("li", { key: i++ },
                React.createElement("span", { className: "error" }, "[Error] "),
                error));
        });
        this.props.warns.forEach((warning) => {
            list.push(React.createElement("li", { key: i++ },
                React.createElement("span", { className: "warning" }, "[Warning] "),
                warning));
        });
        this.props.infos.forEach((info) => {
            list.push(React.createElement("li", { key: i++ },
                React.createElement("span", { className: "info" }, "[Info] "),
                info));
        });
        if (this.props.debugs.length > 0) {
            React.createElement("li", { key: i++ },
                React.createElement("span", { className: "debug" }, "[Debug] "),
                "Debug messages are not shown in the editor. Open the browser console to view debug logs.");
        }
        if (list.length === 0) {
            list.push(React.createElement("li", { key: 'no error' },
                React.createElement("span", { className: "info" }, "[Info] "),
                "No error, infos, or warnings"));
        }
        return (React.createElement("div", { className: "error-pane" },
            React.createElement("ul", null, list)));
    }
}
